package de.emgress.baskets.modules.components

import androidx.compose.runtime.Composable
import core.enums.ELinks
import de.emgress.baskets.core.enums.EIconButton
import de.emgress.baskets.core.styles.Styles
import kotlinx.browser.window
import org.jetbrains.compose.web.dom.*

@Composable
fun IconButton(
    text: String,
    specificLink: String?,
    buttonType: EIconButton
) {
    val userAgent = window.navigator.userAgent
    val navigationLink = when(buttonType) {
        EIconButton.APP_LIVETICKER -> {
            if (userAgent.contains("iPhone") || userAgent.contains("iPad")) {
                ELinks.APPLE_APP_STORE.mUrl
            } else if (userAgent.contains("Android")) {
                ELinks.GOOGLE_PLAY_STORE.mUrl
            } else {
                ELinks.LANDINGPAGE_APPS.mUrl
            }
        }
        EIconButton.SPORTDEUTSCHLAND_TV -> {
            specificLink ?: ELinks.SPORTDEUTSCHLAND_TV.mUrl
        }
    }

    val imageResource = window.location.search.contains("darkmode=true").let {
        if (it) buttonType.mImageNameDark ?: buttonType.mImageNameLight else buttonType.mImageNameLight
    }

    Div({
        classes(Styles.cssClasses.column, Styles.cssClasses.iconContainer, Styles.cssClasses.barlowFont)
    }) {
        A(
            href = navigationLink,
            attrs = {
                attr("target", "_blank")
            }
        ) {
            Div({
                classes(Styles.cssClasses.rowCentered)
            }) {
                Img(
                    attrs = { classes(if (buttonType == EIconButton.SPORTDEUTSCHLAND_TV) Styles.cssClasses.logo else Styles.cssClasses.fillableIcon) },
                    src = "/images/${imageResource}"
                )
            }
            Div({
                classes(Styles.cssClasses.rowCentered)
            }) {
                P {
                    Text(text)
                }
            }
        }
    }
}